import { authSagas } from "./auth/sagas";
import {
  connectionSagas,
  connectionStatusListenerSaga,
} from "./connection/sagas";
import { reloadDeletedDevicesSaga } from "./deleted-devices/sagas";
import {
  deviceStatusInitSaga,
  deviceStatusListenerSaga,
} from "./device-statuses/sagas";
import { deviceSagas } from "./devices/sagas";
import {
  devicesLastSeenInitSaga,
  devicesLastSeenListenerSaga,
} from "./last-seen-devices/sagas";
import { networkSagas } from "./networks/sagas";
import { tasksSaga } from "./tasks/sagas";
import { globalPageSagas } from "./ui-state";
import { userContentSagas } from "./user-contents/sagas";
import {
  forgotPasswordSaga,
  getUsersSaga,
  resetPasswordSaga,
} from "./users/sagas";

type SagaEffect = Generator<unknown, unknown, unknown>;

// These will be loaded across all apps.
const rootSagas: SagaEffect[] = [
  connectionStatusListenerSaga(),
  deviceStatusInitSaga(),
  deviceStatusListenerSaga(),
  devicesLastSeenInitSaga(),
  devicesLastSeenListenerSaga(),
  forgotPasswordSaga(),
  getUsersSaga(),
  reloadDeletedDevicesSaga(),
  resetPasswordSaga(),
  tasksSaga(),
  ...authSagas,
  ...connectionSagas,
  ...deviceSagas,
  ...globalPageSagas,
  ...networkSagas,
  ...userContentSagas,
];

export { rootSagas };
